import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MpLoadingButtonComponent } from './mp-loading-button.component';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  declarations: [MpLoadingButtonComponent],
  imports: [
    CommonModule,
    TranslateModule
  ],
  exports: [MpLoadingButtonComponent],
})
export class MpLoadingButtonModule {}
